import type { ReactNode } from "react";

export function Code({ children, block = false }: { children: ReactNode; block?: boolean }) {
  return block ? <pre className="code code--block">{children}</pre> : <code className="code code--inline">{children}</code>;
}
